export default __webpack_public_path__ + "assets/images/e6888a444ff2cbeaca7970a601d20ffe.png";